import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import api from '../services/api';
import { API_URL } from '../env';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const authBypassActive = process.env.REACT_APP_DEV_MODE_BYPASS_AUTH === 'true';
  const bypassUser = useMemo(
    () =>
      authBypassActive
        ? {
            email: 'devmode@example.com',
            name: 'Dev Mode Administrator',
            groups: ['admin'],
            is_admin: true,
            authenticated: true,
          }
        : null,
    [authBypassActive]
  );

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get('/api/user/me');
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (authBypassActive && bypassUser) {
      setUser(bypassUser);
      setLoading(false);
      return;
    }
    fetchMe();
  }, [authBypassActive, bypassUser, fetchMe]);

  const login = () => {
    if (authBypassActive && bypassUser) {
      setUser(bypassUser);
      setLoading(false);
      return;
    }
    window.location.href = `${API_URL}/api/auth/login`;
  };

  const logout = async () => {
    if (authBypassActive && bypassUser) {
      setUser(bypassUser);
      setLoading(false);
      return;
    }
    try {
      await api.post('/api/auth/logout');
      setUser(null);
      window.location.href = '/';
    } catch (e) {
      console.error('Logout failed', e);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, authBypassActive }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
